import { articles } from "./articles";
import { users } from "./users";

export const deps = {
  articles,
  users
};